<div class="sku-nest-summary">
  <div class="header-row">
    <div
      class="col"
      [class.disabled-nest]="
        col.label === '1 SKU Nest' || col.label === '2 SKU Nest'
      "
      *ngFor="let col of displayData"
    >
      {{ col.label }}
      <img
        *ngIf="col.label === '1 SKU Nest' || col.label === '2 SKU Nest'"
        src="/assets/images/info.svg"
        alt="icon"
        pTooltip="Optimization does not work on this SKU Nest"
        tooltipPosition="top"
        class="cursor-pointer info-icon"
      />
    </div>
  </div>
  <div class="content-row">
    <div class="col" *ngFor="let col of displayData">
      <ng-container *ngIf="!showLoader; else skeletonTpl">
        <span class="count">
          {{ col.nests }} nests
          <span class="percent">({{ formatPercent(col.percent) }})</span>
        </span>
      </ng-container>
      <ng-template #skeletonTpl>
        <p-skeleton width="80%" height="14px"></p-skeleton>
      </ng-template>
    </div>
  </div>
</div>
